import React, { useEffect, useState } from 'react';
import './style.less';
import { LocaleString, getString } from '@nackle/intl-tools';
import solutionFetch from './solution';
import contentFetch from './content';
/* eslint-disable */
import regeneratorRuntime from 'regenerator-runtime';
/* eslint-enable */
const App = ( { ssoEndpoint, identity, environment, buttonText, subText, locale, accessToken } ) => {
    const [ solution, setSolution ] = useState();
    const [ contentFetched, setContentFetched ] = useState( false );
        useEffect( () => {
            async function getSolutionAndContent() {
                const fetched = await solutionFetch( accessToken, environment, identity );
                const content = await contentFetch( accessToken, environment, locale );
                setSolution( fetched );
                if ( content && content.success ) {
                    setContentFetched( true );
                }
            }
            if ( !solution ) {
                getSolutionAndContent();
            }
          }, [] );

        let domain = 'recognition-now.io';
        if ( solution && solution.solutions && solution.solutions.length > 0 ) {
            domain = solution.solutions[ 0 ].domain;
            if ( solution.solutions[ 0 ].customDomains && solution.solutions[ 0 ].customDomains.length > 0 ) {
                domain = solution.solutions[ 0 ].customDomains[ 0 ];
            }
        }
        return (
            <div className="celebration-moments-container">
                {
                    contentFetched &&
                    <>
                    <img src={ 'https://api.biw.cloud/v1/images/CelebrationMoments.png' } alt={ getString( 'celebration.moments.subText' ) } />
                    <div className="sub-text">{ subText || <LocaleString code="celebration.moments.subText" /> }</div>
                    <form
                        action={ ssoEndpoint }
                        className="celebrations-form"
                        id={ 'celebrationsForm' }
                        method="POST"
                        target="_blank"
                    >
                        <input
                            type="hidden"
                            name="location"
                            value={ `https://${ identity }.${ environment && environment !== 'prod' ?  `${ environment }.` : '' }${ domain }/home/?celebration=true&locale=${ locale }` }
                        />

                        <button
                            className="celebrations-link btn btn-inverse form-action-btn"
                            id={ 'celebrationsLink' }
                            type="submit"
                        >
                            { buttonText || <LocaleString code="celebration.moments.buttonText" /> }
                        </button>
                    </form>
                    </>
                }
            </div>
        );
};
export default App;